import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Helpers } from '../../../../../../helpers';
import { BaseComponent } from '../../../base.component';
import { Reservation } from '../../../../../../models/reservation';
import { DataService } from '../../../../../../_services/data.service';
import { ReservationService } from '../../../../../../services/reservation.service';
import {
    SelectService,
    SelectEvent
} from '../../../../../../_services/select.service';
import { ReservationSearchModel } from '../../../../../../models/reservationSearchModel';
import { LoadingService } from '../../../../../../_services/loading.service';
import { DatepickerService } from '../../../../../../_services/datepicker.service';
import { ExcelService } from '../../../../../../_services/excel.sevice';
import { ReservationDetail } from '../../../../../../models/reservation-detail';

@Component({
    selector: 'app-reservation-search',
    templateUrl: './reservation-search.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ReservationSearchComponent extends BaseComponent
    implements OnInit {
    model: Reservation = new Reservation();
    reservationSearchModel: ReservationSearchModel = new ReservationSearchModel();
    adUnits: any[] = [];
    startDate: Date;
    endDate: Date;
    reservations: any[] = [];
    updateVisible: boolean = false;
    selectedReservationId: string;

    constructor(
        private reservationService: ReservationService,
        private dataService: DataService,
        private selectService: SelectService,
        private datepickerService: DatepickerService,
        private excelService: ExcelService,
        private loading: LoadingService
    ) {
        super();
        this.model.publisherId = this.dataService.publisherId;
    }
    ngOnInit() {
        var self = this;
        this.selectService
            .init({
                url: '/agencies/list?filterId=' + this.model.publisherId,
                controlId: 'searchAgencyId',
                displayProperty: 'name',
                allowClear: true
            })
            .on(SelectEvent.unselect, function(e) {
                self.reservationSearchModel.agencyId = null;
            })
            .on(SelectEvent.select, function(e) {
                self.reservationSearchModel.agencyId = e.params.data.id;
            });

        this.selectService
            .init({
                url: '/customers/list?filterId=' + this.model.publisherId,
                controlId: 'searchCustomerId',
                displayProperty: 'name',
                allowClear: true
            })
            .on(SelectEvent.unselect, function(e) {
                self.reservationSearchModel.customerId = null;
            })
            .on(SelectEvent.select, function(e) {
                self.reservationSearchModel.customerId = e.params.data.id;
            });

        (<any>$('#dateRange')).datepicker({
            format: 'dd/mm/yyyy',
            todayHighlight: true,
            weekStart: 1
        });
        this.setDefaultDates();
    }
    searchReservation() {
        this.reservationSearchModel.startDate = this.datepickerService.getDate(
            'startDate'
        );
        this.reservationSearchModel.endDate = this.datepickerService.getDate(
            'endDate'
        );

        // this.reservationSearchModel.startDate = Helpers.getUTCDate(
        //   this.reservationSearchModel.startDate
        // );
        // this.reservationSearchModel.endDate = Helpers.getUTCDate(
        //   this.reservationSearchModel.endDate
        // );
        this.loading.show();
        this.reservationService
            .search(this.reservationSearchModel)
            .subscribe(res => {
                this.reservations = res.data;
                this.loading.hide();
            });
        (<any>$('#reservationScrollBar')).mCustomScrollbar();
    }
    setDefaultDates() {
        var date = new Date();
        var firstDay = Helpers.getUTCDate(
            new Date(date.getFullYear(), date.getMonth(), 1)
        );
        var lastDay = Helpers.getUTCDate(
            new Date(date.getFullYear(), date.getMonth() + 1, 0)
        );
        this.datepickerService.setDate('startDate', firstDay);
        this.datepickerService.setDate('endDate', lastDay);
    }

    activateUpdate(reservationid) {
        this.updateVisible = true;
        this.selectedReservationId = reservationid;
    }
    activateReservations() {
        this.updateVisible = false;
        this.selectedReservationId = null;
        this.searchReservation();
    }
    deleteReservation(reservationid) {
        this.swalService.confirmDelete().then(res => {
            if (res.value) {
                this.loading.show();
                this.reservationService.delete(reservationid).subscribe(() => {
                    this.swalService.successDelete();
                    this.searchReservation();
                    this.loading.hide();
                });
            }
        });
    }

    getReservationExcel(reservationid) {
        this.model.id = reservationid;
        this.loading.show();
        this.reservationService.find(this.model.id).subscribe(res => {
            this.model = res.data;
            this.exportExcel(this.model);
            this.loading.hide();
        });
    }

    exportExcel(reservation) {
        var isCity = "";
        if (reservation.reservationCities.length > 0) {
            isCity = "-City"
        }

        var excelDataSource = [];
        var excelDataSourceName = reservation.name + isCity;

        for (let i = 0; i < reservation.reservationDetails.length; i++) {
            var reservationDetail = reservation.reservationDetails[i];

            reservationDetail.reservationDetailDates.sort((a, b) => a.date.localeCompare(b.date));

            for (let i = 0; i < reservationDetail.reservationDetailDates.length; i++) {
                var reservationDetailDate = reservationDetail.reservationDetailDates[i];

                var excelRow = {
                    'Reservation Name': reservation.name,
                    'Target Name':
                    reservationDetail.adUnit.page.site.title +
                    '/' +
                    reservationDetail.adUnit.page.name +
                    '/' +
                    reservationDetail.adUnit.title,
                    'Customer': reservation.customer.name,
                    'Agency': reservation.agency ? reservation.agency.name : "",
                    'Date': new Date(reservationDetailDate.date).toDateString()
                };
                excelDataSource.push(excelRow)
            }
        }
        this.excelService.exportAsExcelFile(
            excelDataSource,
            excelDataSourceName,
            excelDataSource.length
        );

    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/reservation/reservation-search/reservation-search.component.ts